import './quotation.scss';
import { FunctionComponent, useEffect, useState } from "react";
import { BadgeDollarSign, Globe, ShoppingBasketIcon, ShoppingCartIcon} from 'lucide-react'
import { useAppDispatch, useAppSelector } from "../../features/helpers";
import { fetchTokenPrice } from "../../store/AuthSlice";
import { fetchUserQuotes, UserInfo } from "../../store/UserSlice";
import { formatCurrencyBRL4 } from '../../utils/format';

const Quotation: FunctionComponent = () => {

    const dispatch                      = useAppDispatch();
    const price                         = useAppSelector( (state) => state.auth.price );
    const userInfo: UserInfo            = useAppSelector( (state) => state.user.userInfo );
    const loadingPrices: boolean        = useAppSelector( (state) => state.auth.loadingPrices );
    const pricesError: string | null    = useAppSelector( (state) => state.auth.pricesError );
    const [localQuotes, setLocalQuotes] = useState<any[]>([]);

    useEffect(() => {
        dispatch(fetchTokenPrice());

        const interval = setInterval(() => {
            dispatch(fetchTokenPrice());
        }, 5000);

        return () => clearInterval(interval);
    }, [dispatch]);

    useEffect( () => {
        if (price && price.best && userInfo.organizationUsers){
            const updated = userInfo.organizationUsers.map((quote: any) => ({
                ...quote,
                current: (1+(Number(quote.fee)/100)) * price.best.price
            }));
            setLocalQuotes(updated);
        }

    }, [price, userInfo])

    return (
        <div className="quotation-wrapper">

            <h2 className="card no-opacity">
                <Globe size={20} className='icon' /> Cotacao USDT x BRL
            </h2>

            { !price && <div className="loader"></div> }

            { pricesError && <p className="quote-error">{pricesError}</p> }

            {userInfo && userInfo.organizationUsers?.length === 0 && (
                <p>Sem organizacoes para cotar</p>
            )}

            { 
                userInfo &&
                userInfo.organizationUsers?.length > 0 &&
                localQuotes?.length > 0 &&
                localQuotes.map((quote, index) => (
                    <h3 className="quote" key={index}>
                        <div className="quote-head">
                            <div className='org-name'>Cotacao {quote.organization.organizationName}</div>
                            <span className="fee-badge">Taxa {Number(quote.fee)}%</span>
                        </div>
                        <div className="quotes-wrapper">
                            <small>
                                {formatCurrencyBRL4(quote.current)}
                                { loadingPrices && <div className="loader"></div> }
                            </small>
                        </div>
                    </h3>
            ))}

            <div className="buttons">
                <div className="btn buy spaced">
                    <ShoppingCartIcon size={24} /> COMPRAR USDT
                </div>
            </div>

        </div>
        
    )
}

export default Quotation;
